import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../components/CustomComponents/CustomViewPage'
import { usePermissions } from '../../hooks/Authentication/usePermissions'

export default function ViewPermission() {
  const { getPermission, permission, loading } = usePermissions()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getPermission({ permissionId: params.permissionId })
  }, [params.permissionId])

  useEffect(() => {
    if (permission) {
      setData([
        { label: 'Permission Code', data: permission.permissionCode },
        { label: 'Name', data: permission.name },
        { label: 'Permissions', data: permission.allowed, type: 'Array', value: 'module', extraValue: ['subPermission'] },
      ])
    }
  }, [permission])
  return <CustomViewPage loading={loading} heading="Permission" editUrl="permission" id={params.permissionId} redirect="ALL_PERMISSIONS" data={data} />
}
